<div class="container">
    <div class="row">

        <h4 id="upper">
            Paramétrage des poids PDC par année
        </h4>

        <!-- Sélection du PDC -->
        <div class="row mb-4">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header">
                        Sélectionner le PDC à configurer
                    </div>
                    <div class="card-body">
                        <div class="row g-3 d-flex justify-content-end">

                            <div class="col-md-5">
                                <label class="form-label fw-bold">Période PDC</label>
                                <select name="selectedPdc" class="form-select form-select-lg" [(ngModel)]="selectedPdc">
                                    <option [ngValue]="undefined" disabled selected>Veuillez choisir un PDC dans la
                                        liste...</option>
                                    <option *ngFor="let item of pdcData" [ngValue]="item">
                                        {{ item?.annee_debut }} - {{ item?.annee_fin }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-md-2 d-flex align-items-end">
                                <button (click)="getParamPdcPoid()" class="btn btn-primary w-100">
                                    <i class="fas fa-search me-1"></i>
                                    Charger
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


        </div>

        <!-- Configuration des poids -->
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header d-flex justify-content-between align-items-center">
                        <div>
                            Configuration des poids par année
                        </div>
                    </div>
                    <div class="card-body">
                        <!-- Tableau de configuration -->
                        <div class="table-responsive">
                            <table class="table table-config">
                                <thead>
                                    <tr>
                                        <th>Année</th>
                                        <th class="text-center">Poids</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of  poidPdcItems">
                                        <td class="year-cell fw-bold">{{item.annee}}</td>
                                        <td class="text-center col-md-2">
                                            <input type="number" class="form-control" [(ngModel)]="item.poids" min="0">
                                        </td>


                                    </tr>

                                </tbody>
                            </table>
                        </div>

                        <!-- Actions -->
                        <div class="d-flex justify-content-end align-items-center mt-4">
                            <div>
                                <button [disabled] = "isStart" class="btn btn-success btn-action me-2" (click)="configurePdcPoids()">
                                    <i class="fas fa-save me-1"></i>
                                    Enregistrer
                                </button>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>

<ngx-ui-loader></ngx-ui-loader>
<p-toast />